module.exports = __webpack_public_path__ + "static/media/20.8021cc0e.svg";